import Icon from '@ant-design/icons';
import classNames from 'classnames';
import PubSub from 'pubsub-js';
import { useEffect, useMemo } from 'react';

import NewChatSvg from '@/components/Icon/svgs/new-chat.svg';
import RightSvg from '@/components/Icon/svgs/right.svg';
import { CONTAINER_EVENT } from '@/components/chat-app/utils/utils';
import useGeniusLayout from '@/hooks/useGeniusLayout';
import { useModel } from '@/hooks/useModel';
import { EVENT } from '@/utils/event';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';

import styles from './index.less';

interface IProps {
  iconType?: 'new' | 'back';
}

function NewChat(props: IProps): JSX.Element {
  const { iconType = 'new' } = props;
  const { isLogin } = useModel('auth-model', (model) => ({ isLogin: model.isLogin }));
  const { type } = useGeniusLayout();
  const isPa = type === 'pa';

  const icon = useMemo(() => {
    switch (iconType) {
      case 'new':
        return <Icon className={styles.icon} component={NewChatSvg} />;
      case 'back':
        return <Icon className={styles.icon} component={RightSvg} rotate={180} />;
    }
  }, [iconType]);

  const handleStartNewChat = () => {
    if (!isLogin) {
      dispatchEvent(new CustomEvent(CONTAINER_EVENT.NEED_LOGIN));
    } else {
      if (isPa) {
        dispatchEvent(new Event(CONTAINER_EVENT.ONBOARD));
        dispatchEvent(new Event(CONTAINER_EVENT.CLOSE_SESSION));
      } else {
        dispatchEvent(new Event(CONTAINER_EVENT.RESTART_SESSION));
      }

      dispatchEvent(new Event(EVENT.CLOSE_TASK_LIST));
      dispatchEvent(new CustomEvent(CONTAINER_EVENT.CHAT_INPUT_FOCUS));
      // 用于更新chat标题
      PubSub.publish(EVENT.NEW_CHAT_CALLBACK);
      reportClick(EReportClickKey.clicked_layout_top_bar, { key1: 'new_task' });
    }
  };

  useEffect(() => {
    addEventListener(EVENT.CLICK_NEW_CHAT_BUTTON, handleStartNewChat);

    return () => {
      removeEventListener(EVENT.CLICK_NEW_CHAT_BUTTON, handleStartNewChat);
    };
  }, []);

  return (
    <div
      className={classNames(styles.btnWrap, { [styles.onlyIcon]: true })}
      onClick={() => handleStartNewChat()}
    >
      {icon}
    </div>
  );
}

export default NewChat;
